<ion-header>
  <ion-toolbar>
    <ion-title>{{address_type}} Customer</ion-title>
    <ion-button slot="end" fill="clear" class="white_color" color="primary-pos-bg" (click)="close()">
      <ion-icon class="close_icon" name="close-sharp"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <form [formGroup]="newCustomer">
      <ion-item lines="none" class="">
        <ion-label position="stacked">First Name <span class="err">*</span></ion-label>
        <ion-input name="first_name" class="form-input" autofocus="true" autocomplete="false" formControlName="first_name"></ion-input>
      </ion-item>
      <p *ngIf="submitted && newCustomer.get('first_name').errors && newCustomer.get('first_name').errors.required">Enter First Name</p>
      <ion-item lines="none" class="">
        <ion-label position="stacked">Last Name</ion-label>
        <ion-input name="last_name" class="form-input" autofocus="true" autocomplete="false" formControlName="last_name"></ion-input>
      </ion-item>
      <ion-item lines="none" class="">
        <ion-label position="stacked">Phone <span class="err">*</span></ion-label>
        <ion-input type="text" name="phone" class="form-input" autofocus="true" autocomplete="false" formControlName="phone" (ionChange)="format_phone($event)"></ion-input>
      </ion-item>
      <p *ngIf="submitted && newCustomer.get('phone').errors">Please enter a valid phone number</p>
      <ion-item lines="none" class="">
        <ion-label position="stacked">Email</ion-label>
        <ion-input name="email" class="form-input" formControlName="email" autocomplete="false"></ion-input>
      </ion-item>
      <!-- <ion-item lines="none" class="">
        <ion-label position="stacked">Role</ion-label>
        <ion-select name="custom_role" formControlName="custom_role" class="form-input p8" interface="popover" (ionChange)="value_changed($event)">
          <ion-select-option *ngFor="let c of role_list" value="{{c.role}}">{{c.role}}</ion-select-option>
        </ion-select>
      </ion-item> -->
    </form>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar class="ion__toolbar">
    <div [formGroup]="newCustomer" class="ion__button">
      <ion-button (click)="address_type == 'Edit'? new_customers(newCustomer.value): customers()" fill="clear" expand="full">{{address_type == 'Edit'?'Update':'Save'}}</ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
